// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2WenO","signatureButtonsRight":"ModalSign_signatureButtonsRight__2zoK8"};